<mat-dialog-content>
  <h2 class="sticky-top">Label Dictionary</h2>
  <app-label-dictionary (closeEmitter)="close()"></app-label-dictionary>
</mat-dialog-content>
